import { BaseFilterAgent } from './base-filter-agent';

/**
 * Manage the creation/removal and show/hide of Dropdown Selector Filter view<br>
 * Call FilterService to change filter state<br>
 * @extends BaseFilterAgent
 */
export class SelectorFilterAgent extends BaseFilterAgent {
  constructor(options) {
    super(options);
    const selectorConf = {
      id: 'selector-filter',
      items: this.options.selector.items,
      onChange: item => this.apply(item),
      checkKeyDifferenceOnClick: this.options.selector.checkKeyDifferenceOnClick || false,
    };

    if (options.filter && options.filter.key) {
      selectorConf.selectedKey = options.filter.key;
    } else {
      const defaultSelectedItem = this.options.selector.items[0];
      if (defaultSelectedItem.value && defaultSelectedItem.value.query) {
        selectorConf.selectedKey = defaultSelectedItem.key;
        this.apply(defaultSelectedItem);
      }
    }

    if (this.options.toolbarView.rendered) {
      this.options.toolbarView.view.update(selectorConf);
    } else {
      this.options.toolbarView.once('rendered', () => {
        this.options.toolbarView.view.update(selectorConf);
      });
    }
  }

  /**
   * Apply filter
   * @private
   * @param {Object} item - One item in the selector dropdown
   * @param {string} item.key - The item key
   * @param {Object} item.value - A query object
   * @returns {undefined}
   */
  apply(item) {
    this.options.filterService.setQuickFilter(item.key, item.value);
  }
}
